/*
 * ===============================================================================================================
 *                                Copyright 2021, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */


import { IRole } from "../../models/Roles/RolesContracts"
import {
  GET_ROLES,
  SET_ROLE_SEARCH_VALUE,
  SET_NO_ROLES,
  SET_SELECTED_ROLE,
  SET_FILTERED_ROLES,
  GET_ROLE_OF_SUBJECT,
  RESET_ROLES,
  SET_DATA_PLATFORM_ACTIONS, EXPORT_ROLES_SUCCESS, EXPORT_ROLES_FAILURE, EXPORT_ROLES_REQUEST
} from './types';
import { IAction, IResourceType } from '../../models/Policies/PolicyContract';

export const setRoleSearchValue = (searchValue?: string) => {
  return {
    type: SET_ROLE_SEARCH_VALUE,
    searchValue
  }
}
export const getRoleListAction = (roleList: IRole[]) => {
  return {
    type: GET_ROLES,
    roleList
  }
}
export const setHasNoRolesAction = (setNoRoles: boolean) => {
  return {
    type: SET_NO_ROLES,
    setNoRoles
  }
}
export const getRoleOfSubjectAction = (getRoleOfSubject: IRole[]) => {
  return {
    type: GET_ROLE_OF_SUBJECT,
    getRoleOfSubject
  }
}

export const setSelectedRoleAction = (selectedRoleItem: IRole) => {
  return {
    type: SET_SELECTED_ROLE,
    selectedRoleItem
  };
};

export const setFilteredRoleAction = (filteredRoles: IRole[]) => {
  return {
    type: SET_FILTERED_ROLES,
    filteredRoles,

  };
};
export const resetRolesState = () => {
  return {
    type: RESET_ROLES
  };
};

export const setDataPlatformActions = (dataPlatformActions: IAction[], policyResourceTypes: IResourceType[]) => {
  return {
    type: SET_DATA_PLATFORM_ACTIONS,
    dataPlatformActions,
    policyResourceTypes
  };
};

export const fetchExportRequest = () => {
  return {
    type: EXPORT_ROLES_REQUEST
  };
};
export const fetchExportSuccess = (data: any) => {
  return {
    type: EXPORT_ROLES_SUCCESS,
    rolesExported: data
  };
};

export const fetchExportFailure = (error: any) => {
  return {
    type: EXPORT_ROLES_FAILURE,
    error
  };
};
